<template>
    <TheModal v-if="visible" class="sm" @close="close">
        <template v-slot:head>Корректировка баланса</template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form" @submit.prevent="submit">
            <ValidationProvider v-errors.api vid="amount" tag="div" class="form-group mb-2" rules="required|decimal:2|min_value:0.1|max_value:1000000">
                <label for="amount">Сумма, {{ currency | currencySymbol }}</label>
                <input id="amount" v-model="form.amount" type="text" class="form-control mr-3">
            </ValidationProvider>

            <div class="form-group mb-4">
                <div class="custom-control custom-radio custom-control-inline">
                    <input id="type_1" v-model.number="form.type" type="radio" class="custom-control-input" value="1">
                    <label class="custom-control-label" for="type_1">Зачисление на счет</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input id="type_2" v-model.number="form.type" type="radio" class="custom-control-input" value="2">
                    <label class="custom-control-label" for="type_2">Списание со счета</label>
                </div>
            </div>

            <ValidationProvider v-errors.api vid="comment" tag="div" class="form-group" rules="required|min:15">
                <label for="comment">Комментарий</label>
                <textarea id="comment" v-model="form.comment" type="text" class="form-control" />
            </ValidationProvider>

            <ValidationProvider v-errors.api vid="agree" tag="div" class="custom-control custom-checkbox my-4">
                <input id="agree" v-model="agree" type="checkbox" class="custom-control-input">
                <label class="custom-control-label" for="agree">Я в здравом уме и трезвой памяти</label>
            </ValidationProvider>

            <button type="button" class="btn btn-primary btn-lg-192" :disabled="invalid || !agree || penging" @click="submit">
                {{ form.type === 1 ? 'Начислить' : 'Списать' }}
            </button>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import TheModal from '@/components/TheModal'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

const form = {
    amount: null,
    type: 1,
    comment: ''
}

export default {
    components: {
        TheModal,
        ValidationProvider,
        ValidationObserver
    },

    props: {
        currency: {
            type: Number,
            default: null
        },

        penging: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            form: { ...form },
            agree: false,
            visible: false
        }
    },

    methods: {
        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            this.$emit('submit', this.form)
        },

        show() {
            this.visible = true
        },

        close() {
            this.visible = false

            this.form = { ...form }
            this.agree = false

            this.$refs.obs.reset()
        },

        mixinApiErrors(errors) {
            mixinApiErrors(this.$refs.obs, errors)
        }
    }
}
</script>
